import React from 'react';
import SimpleAudioPlayer from './media/SimpleAudioPlayer';

const CombinedMessage = ({ message, isSender }) => {
  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString([], { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const getFileIcon = (fileType) => {
    if (fileType.startsWith('image/')) return '🖼️';
    if (fileType.startsWith('video/')) return '🎥';
    if (fileType.startsWith('audio/')) return '🎵';
    if (fileType.includes('pdf')) return '📄';
    return '📎';
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div className={`flex ${isSender ? 'justify-end' : 'justify-start'} mb-4`}>
      <div className={`max-w-[70%] rounded-2xl p-3 shadow-sm ${
        isSender 
          ? 'bg-green-100 dark:bg-green-900 border border-green-200 dark:border-green-700' 
          : 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700'
      }`}>
        {/* Media Attachments */}
        {message.attachments && message.attachments.length > 0 && (
          <div className="mb-2 space-y-2">
            {message.attachments.map((attachment) => (
              <div key={attachment.id} className="rounded-lg overflow-hidden">
                {attachment.preview && attachment.type.startsWith('image/') ? (
                  // Image Preview
                  <div className="relative">
                    <img
                      src={attachment.preview}
                      alt={attachment.name}
                      className="w-full max-w-[300px] h-auto rounded-lg object-cover"
                    />
                  </div>
                ) : attachment.type.startsWith('video/') ? (
                  // Video Player
                  <div className="video-preview-container">
                    <video
                      src={attachment.preview || URL.createObjectURL(attachment.file)}
                      className="w-full max-w-[300px] h-auto rounded-lg"
                      controls
                      preload="metadata"
                    >
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ) : attachment.type.startsWith('audio/') ? (
                  // Audio Player for voice recordings
                  <SimpleAudioPlayer
                    audioUrl={attachment.preview || URL.createObjectURL(attachment.file)}
                    fileName={attachment.name}
                    fileSize={attachment.size}
                    isSender={isSender}
                  />
                ) : (
                  // File Card for other file types
                  <div className={`flex items-center gap-3 p-3 rounded-lg ${
                    isSender 
                      ? 'bg-green-50 dark:bg-green-800' 
                      : 'bg-gray-50 dark:bg-gray-700'
                  }`}>
                    <div className="w-10 h-10 rounded-lg bg-gray-200 dark:bg-gray-600 flex items-center justify-center text-lg">
                      {getFileIcon(attachment.type)}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">
                        {attachment.name}
                      </p>
                      <p className="text-xs text-gray-500 dark:text-gray-400">
                        {formatFileSize(attachment.size)}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Text Content */}
        {message.text && message.text.trim() && (
          <div className={`${message.attachments && message.attachments.length > 0 ? 'mt-2' : ''}`}>
            <p className={`text-sm leading-relaxed ${
              isSender 
                ? 'text-gray-800 dark:text-gray-200' 
                : 'text-gray-700 dark:text-gray-300'
            }`}>
              {message.text}
            </p>
          </div>
        )}


        {/* Timestamp */}
        <div className={`flex justify-end mt-1 ${
          isSender ? 'text-green-700 dark:text-green-300' : 'text-gray-500 dark:text-gray-400'
        }`}>
          <span className="text-xs">{formatTime(message.timestamp)}</span>
        </div>
      </div>
    </div>
  );
};

export default CombinedMessage;
